<template>

  <tbody class="hit-html-tbody">

    <tr class="hit-html-tr" v-if="!data || !data.length ">

      <td class="hit-html-td hit-text-danger" v-bind:colspan="titles.length" v-html='$tc("message.noEntry", 2)'/>

    </tr>

    <tr class="hit-html-tr" v-for="(entry, index) in data" v-if="data && data.length">

      <td class="hit-html-td" v-for="(value, index2) in Object.values(entry)">

        <a
          href="#"
          class="hit-html-a" style="color: inherit;"

          v-if="actions[index2] && typeof actions[index2] == 'function'"
          v-on:click.prevent="set_action(value, index, index2)"
        >

          <span v-if="typeof value == 'object'">
            <component v-bind:is="value[0]" v-bind="value[1]"/>
          </span>

          <span v-else v-html="value"></span>

        </a>

        <span v-else-if="typeof value == 'object'">
          <component v-bind:is="value[0]" v-bind="value[1]"/>
        </span>

        <span v-else v-html="value"></span>

      </td>

    </tr>

  </tbody>

</template>

<script>

export default{

  props: { data: Array, actions: Array, titles: Array },

  methods: {

    set_action: function (value, row, column) {
      this.actions[column](value, row, column)
    }

  }
}

</script>
